import type { AbsenceSyncSettings } from './types';

export const emptyAbsenceSyncSettings: AbsenceSyncSettings = {
  version: 0, calendarEnabled: false, slackStatusEnabled: false,
  timeZone: 'Asia/Seoul', workdayStart: '09:30', workdayEnd: '19:00', halfDayBoundary: '14:30',
};

export function absenceSyncSettingsError(settings: AbsenceSyncSettings, saved?: AbsenceSyncSettings): string | undefined {
  try { new Intl.DateTimeFormat('ko-KR', { timeZone: settings.timeZone }).format(); }
  catch { return '올바른 시간대를 입력해 주세요. 예: Asia/Seoul'; }
  if (!settings.timeZone.trim()) return '시간대를 입력해 주세요.';
  const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!clock.test(settings.workdayStart) || !clock.test(settings.workdayEnd)) return '근무 시작과 종료 시간을 모두 입력해 주세요.';
  if (settings.workdayStart >= settings.workdayEnd) return '근무 종료는 시작 이후로 입력해 주세요.';
  const sameSavedSchedule = saved && saved.version > 0 && settings.workdayStart === saved.workdayStart && settings.workdayEnd === saved.workdayEnd && settings.timeZone === saved.timeZone;
  if (sameSavedSchedule) return undefined;
  if (settings.workdayStart >= '11:30' || settings.workdayEnd <= '16:30') return '반차·반반차 연동을 위해 근무 시작은 11:30 이전, 종료는 16:30 이후로 입력해 주세요.';
  return undefined;
}
